import React, { useContext } from "react";
import lang from "translations";
import { HeaderC } from "components/headers";
import { Path } from "paths";
import { TabBar, Title } from "components/commons";
import { formatDate } from "services";
import { DateTime, IntegrationType } from "enums";
import BookingStatusPill from "../booking-status-pill";
import { normalizeBookingStatus } from "services/pretty.service";
import { VenueContext } from "contexts";
import { isEatappVenue } from "services/venue.service";

const BookingDetailsHeader = ({ data, loading, id }) => {
  const { venue } = useContext(VenueContext);
  // A SOAR venue calls these reservations, every other venue calls them bookings. This also
  // gates the Accommodation tab, which has to agree with the route gate in
  // booking-details.page.js.
  const isEatapp = isEatappVenue(venue);

  const formatDescription = (bookedAt, bookedBy, integrationName) => {
    return (
      <p className="text-sm">
        Booked on <strong className="text-sm">{formatDate(bookedAt, DateTime.C) ?? "-"}</strong> by{" "}
        <strong className="text-sm">{bookedBy ?? "-"}</strong> from{" "}
        <strong className="text-sm">{integrationName ?? "-"}</strong>
      </p>
    );
  };

  return (
    <>
      <HeaderC
        loading={loading}
        customTitle={
          <div className="flex items-center gap-3">
            <Title xl className="font-semibold">
              {`${isEatapp ? lang.reservationNo : lang.bookingNo} ${data.bookingNumber}`}
            </Title>
            <BookingStatusPill status={normalizeBookingStatus(data)}></BookingStatusPill>
          </div>
        }
        customDescription={formatDescription(
          data.bookedAt,
          data.bookedBy,
          data.integrationName || IntegrationType.MEWS
        )}
        returnText={isEatapp ? lang.reservations : lang.bookings}
        returnPath={Path.BOOKING}
      />
      <TabBar
        className="mb-md"
        items={[
          { to: Path.BOOKING_SUMMARY_NAV(id), text: lang.summary },
          { to: Path.BOOKING_GUESTS_NAV(id), text: lang.guests },
          ...(!isEatapp
            ? [{ to: Path.BOOKING_ACCOMMODATION_NAV(id), text: lang.accommodation }]
            : []),
        ]}
      ></TabBar>
    </>
  );
};

export default BookingDetailsHeader;
